import {adminHttpClient} from "../commons/adminHttpClient";


const getNewsAuditView = (id : string) : Promise<any> => {
    return adminHttpClient.get(`/NewsAudits/View/${id}`);
}

export default getNewsAuditView;